<oo-loading-container [status]="state.status">
  <ng-template>
    <h1 mat-dialog-title>Create {{ state.team.name }} players</h1>
    <mat-dialog-content [formGroup]="state.form">
      <mat-form-field>
        <textarea
          [placeholder]="'Player Name 1, Player Name 2'"
          formControlName="names"
          matInput
          rows="12">
        </textarea>
        <mat-hint>Add multiple players separated by a comma</mat-hint>
        <mat-error>Required</mat-error>
      </mat-form-field>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button mat-dialog-close>
        Cancel
      </button>
      <button (click)="createPlayers()"
              [disabled]="state.form.invalid"
              [mat-dialog-close]="true"
              color="primary"
              mat-button>
        Confirm
      </button>
    </mat-dialog-actions>
  </ng-template>
</oo-loading-container>
